import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        boxShadow: (props) => `2px 5px 5px 0px ${props.color ? 'darkgrey' : 'lightgrey'}`,
        border: (props) => `1px solid ${props.color ? theme.palette[props.color].dark : 'lightgrey'}`,
        borderRadius: 5,
        marginBottom: 10,
        overflow: 'hidden',

        '&::before': {
            backgroundColor: 'transparent'
        }
    },

    heading: {
        background: (props) => (props.isSeperator || props.isSeparator ? 'grey' : props.color ? theme.palette[props.color].dark : ''),
        color: (props) => (props.color ? theme.palette[props.color].contrastText : ''),
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
        borderBottom: (props) => `1px solid ${props.color ? theme.palette[props.color].dark : 'lightgrey'}`,

        '& .MuiIconButton-edgeEnd': {
            color: 'inherit'
        }
    }
}));

const SimpleAccordion = (props) => {
    const isSep = Boolean(props.isSeperator || props.isSeparator);
    const classes = useStyles({ ...props, isSeperator: isSep });
    const [expand, setExpand] = useState({ open: false });
    useEffect(() => {
        if (!isSep) {
            setExpand((st) => ({ ...st, open: props.Expand }));
        }
    }, [props.Expand, props.changedAt, isSep]);
    const handleChange = (event, isExpanded) => {
        if (!isSep) {
            setExpand((st) => ({ ...st, open: isExpanded }));
        }
    };
    return (
        <Accordion
            className={classes.root}
            key={props.accKey}
            expanded={isSep ? false : expand.open}
            onChange={isSep ? undefined : handleChange}
            {...props}
            style={{
                ...(isSep ? { background: 'grey' } : {}),
                ...props.style
            }}
        >
            <AccordionSummary
                expandIcon={isSep ? null : <ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className={classes.heading}
                style={{
                    maxHeight: 30,
                    ...(isSep ? { cursor: 'default', background: 'grey' } : {})
                }}
            >
                {props.header}
            </AccordionSummary>
            {!isSep && (
                <AccordionDetails className={classes.body}>{props.accordianBody || props.children}</AccordionDetails>
            )}
        </Accordion>
    );
};

SimpleAccordion.defaultProps = {
    Expand: false
};

export default SimpleAccordion;
